export const TrezorDerivationPathType = {
    Bip32: 'bip32',
    Bip44: 'bip44',
    Legacy: 'legacy',
};
